// import pages
import React, { useState, useEffect } from "react";
import FooterB from "../layout/FooterB";
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import HeroSection from "../layout/HeroSection";
import ClassesIndexSection from "../layout/ClassesIndexSection";
import ClassesScheduleTable from "../layout/ClassesSchedulTable";
import ClassesSection from "../layout/ClassesSection";
import RegistrationBtnGroup from "../layout/RegistrationBtnGroup";
import { getClassesPage } from "../../sanityClient";

// import style
import "../../style/pages/classes/classes.scss";

// Component map to render different section types
const componentMap = {
  heroSection: HeroSection,
  indexSection: ClassesIndexSection,
  classesScheduleTable: ClassesScheduleTable,
  classesSection: ClassesSection,
  registrationBtnGroup: RegistrationBtnGroup,
  footerB: FooterB,
  subHeader: SubHeader,
  subFooter: SubFooter,
  // Add more components as needed
};

const Classes = () => {
  const [pageData, setPageData] = useState({
    pageSections: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const data = await getClassesPage();
        if (data) {
          setPageData(data);
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Render a section based on its type
  const renderSection = (section, index) => {
    const SectionComponent = componentMap[section._type];
    
    if (!SectionComponent) {
      console.warn(`Unknown section type: ${section._type}`);
      return null;
    }

    // Pass the appropriate props based on section type
    switch (section._type) {
      case 'heroSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            subTitle={section.subTitle}
            backgroundColorClass={section.backgroundColorClass}
            linkPath={section.linkPath}
            enContent={section.enContent}
            jpContent={section.jpContent}
            questionLinkText={section.questionLink}
            questionLinkJpText={section.questionLinkJp}
          />
        );
      case 'indexSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          titleJP={section.titleJP}
          subtitles={section.subtitles} // dynamic array of subtitles
          items={section.items}         // dynamic array of items
          bottomText={section.bottomText}
          bottomTextJP={section.bottomTextJP}
        />;
        case 'classesScheduleTable':
          return (
            <div className="classes-view-section">
              <div className="container classes-view-main">
                <ClassesScheduleTable
                  key={section._key || index}
                  title={section.title}
                  subtitle={section.subtitle}
                  season={section.season}
                  scheduleRows={section.scheduleRows}
                  note={section.note}
                />
              </div>
            </div>
        );
      case 'classesSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            titleJP={section.titleJP}
            titleBackgroundColor={section.titleBackgroundColor}
            titleBackgroundSize={section.titleBackgroundSize}
            id={section.id}
            subtitles={section.subtitles}
            tags={section.tags}
            contentEN={section.contentEN}
            contentJP={section.contentJP}
          />
        );
      case 'registrationBtnGroup':
        return <SectionComponent
          key={section._key || index}
          buttons={section.buttons}
        />;
      case 'footerB':
        return <SectionComponent key={section._key || index} />;
      case 'subHeader':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      case 'subFooter':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      default:
        return null;
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional loading state
  }

  return (
    <div className="classes-section">
      {pageData.pageSections && pageData.pageSections.length > 0 ? (
        pageData.pageSections.map((section, index) => renderSection(section, index))
      ) : (
        // Fallback to default structure if no sections are defined
        <>
          <div className="error-container container main-section">
            <div className="responsive-main-section">
              <div className="title-section background-pink">
                <div className="title-link">
                  <div className="title font-amaticsc-bold">Oops!</div>
                  <div className="sub-title font-zenkurenaido">おっと！</div>
                </div>
              </div>
              <div className="content-section">
                <div className="en-content font-outfit-bold">
                  Something went wrong while loading the classes. Please try again later.
                  <br /><br />
                  Have a question for Ben-sensei? Feel free to ask it <a href="/question" className="en-question-link">here!</a>
                </div>
                <div className="jp-content font-kleeone">
                  ページの読み込み中に問題が発生しました。しばらくしてからもう一度お試しください。
                  <br /><br />
                  ベン先生に質問がありますか？ ぜひ<a href="/question" className="jp-question-link">こちらから</a>質問してください！
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Classes;